import LogoWhite from '_assets/landingPage/images/logo-white.svg'
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';


export function Footer({setShowLogin,setShowRegister}) {

  const [t, i18n] = useTranslation();




  //i18n.changeLanguage('fi')



  // const observer = new IntersectionObserver((entries) => {
  //   entries.forEach((entry) => {
  //     console.log(entry)
  //     if (entry.isIntersecting) {
  //       entry.target.classList.add('show');
  //     } else {
  //       entry.target.classList.remove('show');
  //     }
  //   });
  // });
  useEffect(() => {
    // const hiddenElements = document.querySelectorAll('.');
    // console.log(hiddenElements)
    // hiddenElements.forEach((el) => observer.observe(el));

    const hamburgerButton = document.getElementById('hamburger');
    const mobileMenu = document.getElementById('mobile-menu');

    if(hamburgerButton && mobileMenu)
    // Add click event listener to toggle mobile menu visibility
    hamburgerButton.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden')
    });

    const queryParameters = new URLSearchParams(window.location.search)
    const lang = queryParameters.get('lang')

    i18n.changeLanguage(lang)


  });


  return (

    <section class="mx-auto bg-[#183650] grid md:grid-cols-4 mt-2 rounded-2xl py-8 md:px-2 max-w-[1750px] 2xl:mb-16 text-white text-xl leading-relaxed">
      <div class="flex flex-row mb-8 justify-center md:justify-start items-start px-8">
        <img class="w-[150px]" src="assets/landingpageimages/logo-white.svg" alt="" />
      </div>
      <div class="flex flex-row mb-8 justify-center text-center md:justify-start md:text-left">
        <address>
          <span>{t('footer.contact.name')}</span><br />
          <span>{t('footer.contact.address')}</span><br />
          <span><a href="tel:358505227116">{t('footer.contact.phone')}</a></span><br />
          <span><a href="mailto:info@freightopt.com">{t('footer.contact.email')}</a></span>
        </address>
      </div>
      <div class="flex flex-row mb-8 justify-center text-center md:justify-end md:text-left">
        <nav>
          <ul>
            <li><a href="/aboutUs" class="hover:underline">{t('footer.links.about')}</a></li>
            <li><a href="/howItWorks" class="hover:underline">{t('footer.links.works')}</a></li>
            {/* <li><a href="#" class="hover:underline">{t('footer.links.contact')}</a></li> */}
            <li><a href="/faq" class="hover:underline">{t('footer.links.faq')}</a></li>
          </ul>
        </nav>
      </div>
      <div class="flex flex-row mb-8 text-center justify-center md:justify-center md:text-left">
        <nav>
          <ul>
            <li><a href="#" class="hover:underline" onClick={() => setShowLogin(true)}>{t('footer.auth.login')}</a></li>
            <li><a href="#" class="hover:underline" onClick={() => setShowRegister(true)}>{t('footer.auth.signup')}</a></li>
            {/* <li><a href="#" class="hover:underline">{t('footer.auth.demo')}</a></li> */}
          </ul>
        </nav>
      </div>
    </section>

  )

}
